const FIXED_EXTENSION_RE = /^\d{4}$/;
const DIALED_FULL_RE = /^\$\{EXTEN\}$/;
const DIALED_SUBSTRING_RE = /^\$\{EXTEN:([1-9]\d?)\}$/;
const WILDCARD_RE = /[NXZ]/;
const INTEGER_RE = /^-?\d+$/;

export const INITIAL_DIALED = { mode: 'fixed', digitRemove: '0' };

export const DIALED_MESSAGES = {
  fixedRequired: 'Informe o ramal (4 dígitos) ou escolha "Usar o número discado"',
  fixedFormat: 'Ramal deve conter exatamente 4 dígitos numéricos',
  notInteger: 'Dígitos a remover deve ser um número inteiro',
  negative: 'Dígitos a remover deve ser maior ou igual a 0',
  maxDigits: (max) => `Dígitos a remover deve ser no máximo ${max} para esta máscara`,
};

const cleanMask = (mask) => (typeof mask === 'string' ? mask.trim() : '');

export const isWildcardMask = (mask) => WILDCARD_RE.test(cleanMask(mask));

export const maskLength = (mask) => cleanMask(mask)
  .replace(/^_/, '')
  .replace(/\[[^\]]*\]/g, 'G')
  .replace(/[.!]/g, '')
  .length;

export const maxDigitRemove = (mask) => Math.max(maskLength(mask) - 1, 0);

export const parse = (value) => {
  if (value === undefined || value === null || value === '') return { kind: 'empty' };
  const text = typeof value === 'number' ? String(value) : value;
  if (typeof text !== 'string') return { kind: 'invalid' };
  if (FIXED_EXTENSION_RE.test(text)) return { kind: 'fixed', extension: text };
  if (DIALED_FULL_RE.test(text)) return { kind: 'dialed', digitRemove: 0 };
  const substring = DIALED_SUBSTRING_RE.exec(text);
  if (substring) return { kind: 'dialed', digitRemove: Number(substring[1]) };
  return { kind: 'invalid' };
};

export const compose = (digitRemove) => {
  const digits = Number(digitRemove);
  return digits === 0 ? `\${EXTEN}` : `\${EXTEN:${digits}}`;
};

export const digitRemoveError = (digitRemove, mask) => {
  const text = String(digitRemove ?? '').trim();
  if (!INTEGER_RE.test(text)) return DIALED_MESSAGES.notInteger;
  const digits = Number(text);
  if (digits < 0) return DIALED_MESSAGES.negative;
  const max = maxDigitRemove(mask);
  if (digits > max) return DIALED_MESSAGES.maxDigits(max);
  return null;
};

export const endpointDestinationError = ({ mask, dialed, extension }) => {
  const ramal = typeof extension === 'string' ? extension.trim() : '';
  const wildcard = isWildcardMask(mask);
  if (wildcard && dialed.mode === 'dialed') return digitRemoveError(dialed.digitRemove, mask);
  if (wildcard && !ramal) return DIALED_MESSAGES.fixedRequired;
  if (ramal && !FIXED_EXTENSION_RE.test(ramal)) return DIALED_MESSAGES.fixedFormat;
  return null;
};

export const describeDialedDestination = (destinationType, value) => {
  if (destinationType !== 'endpoint') return null;
  const parsed = parse(value);
  if (parsed.kind !== 'dialed') return null;
  return parsed.digitRemove === 0
    ? 'Número discado'
    : `Número discado sem os ${parsed.digitRemove} primeiros dígitos`;
};
